import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronLeft = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 8,
	height: 12,
	viewBox: "0 0 10 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M6.49994 0.525024L8.44995 2.37502L3.79995 7.02502L8.44995 11.675L6.49994 13.5L0.0999523 7.02502L6.49994 0.525024Z",
		fill: "#5386E4"
	})]
});
const ForwardRef = forwardRef(SvgChevronLeft);
export { ForwardRef as ReactComponent };
